import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Text } from 'components/typography/Text';
import { Image as SemanticImage } from 'semantic-ui-react';
import eventsSrc from 'assets/media/eden/my-workspace/events.jpeg';
import styles from '../styles.module.scss';

export const Events = () => (
  <>
    <SemanticImage
      src={eventsSrc}
      alt="Events"
      className={styles.image}
    />

    <Text size={16}>
      <FormattedMessage
        id="eventsDescription"
        values={{
          bold: (...chunks) => (
            <Text
              size={16}
              element="span"
              bold
            >
              {chunks}
            </Text>
          ),
        }}
      />
    </Text>
  </>
);
